import { apiClient } from '@/services/api';
import { Observable, from } from 'rxjs';
import { map } from 'rxjs/operators';
import { ENDPOINTS } from '@/settings/api-settings';
import IProduct, { ICalorie } from '@/interfaces/product';

function getProductsTest(): Observable<any[]> {
  return from(apiClient.get(ENDPOINTS.PRODUCTS_TEST)).pipe(
    map((r: any) => r.data),
  );
}
function getProducts(filter: any = {}): Observable<IProduct[]> {
  return from(
    apiClient.get(ENDPOINTS.PRODUCT, {
      ativo: filter.status,
    }),
  ).pipe(map((r: any) => (!!r.data ? r.data : [])));
}
function getProduct(id: string): Observable<IProduct> {
  return from(apiClient.get(`${ENDPOINTS.PRODUCTS}/${id}`)).pipe(
    map((r: any) => r.data),
  );
}
function saveProduct(payload: any): Observable<any> {
  return from(apiClient.post(ENDPOINTS.PRODUCTS, payload)).pipe(
    map((r: any) => r.data),
  );
}
function updateProduct(payload: any): Observable<any> {
  return from(apiClient.put(ENDPOINTS.PRODUCTS, payload)).pipe(
    map((r: any) => r.data),
  );
}
function deleteProduct(id: string): Observable<any> {
  return from(apiClient.delete(`${ENDPOINTS.PRODUCTS}/${id}`)).pipe(
    map((r: any) => r.data),
  );
}
function saveFile(id: string, payload: any): Observable<any> {
  return from(
    apiClient.putMultipartFormData(
      `${ENDPOINTS.PRODUCTS}/${id}${ENDPOINTS.PRODUCTS_FILE}`,
      payload,
    ),
  ).pipe(map((r: any) => r.data));
}
function deleteFile(id: string): Observable<any> {
  return from(
    apiClient.delete(`${ENDPOINTS.PRODUCTS}/${id}${ENDPOINTS.PRODUCTS_FILE}`),
  ).pipe(map((r: any) => r.data));
}
function getCalories(): Observable<ICalorie[]> {
  return from(apiClient.get(ENDPOINTS.PRODUCT_CALORIES)).pipe(
    map((r: any) => (!!r.data ? r.data : [])),
  );
}

export {
  getProductsTest,
  getProducts,
  getProduct,
  saveProduct,
  updateProduct,
  deleteProduct,
  saveFile,
  deleteFile,
  getCalories,
};
